import { ButtonGroup, Button, EmptyState } from '@/_components/';
import { FC } from 'react';
import type { ScheduledEmptyStateProps } from './ScheduledEmptyState.types';

export const ScheduledEmptyState: FC<ScheduledEmptyStateProps> = ({
  onSchedule,
}) => {
  return (
    <EmptyState description="No scheduled templates found" icon="file">
      <ButtonGroup align="center">
        <Button
          value="Schedule Questionnaire"
          onClick={onSchedule}
          intent="primary"
          iconLeft="plus"
        />
      </ButtonGroup>
    </EmptyState>
  );
};
